import React, { useState } from "react";
import { HR_PERMISSIONS, hasHrPermission } from "../../constants/hrPermissions";
import AbsenceTab from "./time/AbsenceTab";
import DeviceLogsTab from "./time/DeviceLogsTab";
import MarkAttendanceTab from "./time/MarkAttendanceTab";
import Muster from "./time/Muster";
import MyAttendance from "./time/MyAttendance";
import OvertimeTab from "./time/OvertimeTab";
import TeamToday from "./time/TeamToday";
import { PageHeader, Tabs } from "./hrComponents";
import { useHr } from "./HrGate";
import { pageStyle } from "./hrUi";

// Attendance: my punches and days, who is in today, the muster roll, marking attendance by hand (HR / attendance admins), absence and overtime.
// Everyone sees their own; the team views are limited to the people the person may see (their reports, or everyone for HR).
export default function Attendance() {
  const { access } = useHr();
  const isAdmin = hasHrPermission(access, HR_PERMISSIONS.HR_ADMIN, HR_PERMISSIONS.ATTENDANCE_ADMIN);
  const isEmployee = !!access.is_employee;
  const [tab, setTab] = useState(isEmployee ? "my" : "today");
  const tabs = [
    ...(isEmployee ? [{ key: "my", label: "My attendance" }] : []),
    { key: "today", label: "Team today" },
    { key: "muster", label: "Muster roll" },
    ...(isAdmin ? [{ key: "mark", label: "Mark attendance" }] : []),
    { key: "absence", label: "Absence" },
    { key: "ot", label: "Overtime" },
    ...(isAdmin ? [{ key: "device", label: "Device logs" }] : []),
  ];
  return (
    <div style={pageStyle}>
      <PageHeader title="Attendance" subtitle="Punches, days, absence and overtime" />
      <Tabs tabs={tabs} active={tab} onChange={setTab} />
      {tab === "my" ? <MyAttendance /> : null}
      {tab === "today" ? <TeamToday /> : null}
      {tab === "muster" ? <Muster /> : null}
      {tab === "mark" && isAdmin ? <MarkAttendanceTab /> : null}
      {tab === "absence" ? <AbsenceTab isAdmin={isAdmin} /> : null}
      {tab === "device" && isAdmin ? <DeviceLogsTab /> : null}
      {tab === "ot" ? <OvertimeTab isManager isEmployee={isEmployee} /> : null}
    </div>
  );
}
